import React, { FC } from 'react';
import { Notification } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import {
  MODAL_ACTIONS,
  useModalsContext,
} from '@components/Contexts/ModalsContext';

const ToastNotification: FC = () => {
  const { t } = useTranslation();
  const { toast, dispatchModal } = useModalsContext();

  return (
    <Notification
      theme={toast.theme}
      show={toast.show}
      type="sticky"
      dataHook="toast-notification"
      autoHideTimeout={5000}
      onClose={() => {
        dispatchModal({
          type: MODAL_ACTIONS.HIDE_TOAST,
        });
      }}
    >
      <Notification.TextLabel ellipsis={false}>
        {t(toast.message)}
      </Notification.TextLabel>
      <Notification.CloseButton />
    </Notification>
  );
};

export default ToastNotification;
